import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Calendar from '../../containers/calendar';
import Schedule from '../../containers/schedule';

class TimeslotSelector extends PureComponent {
  getScaledComponent() {
    const { scale } = this.props;
    switch (scale) {
      case 'calendar':
        return Calendar;
      case 'schedule':
      default:
        return Schedule;
    }
  }

  render() {
    const ScaledComponent = this.getScaledComponent();
    return <ScaledComponent {...this.props} />;
  }
}

TimeslotSelector.propTypes = {
  timeslotFilter: PropTypes.func,
  onTimeslotSelect: PropTypes.func.isRequired,
  onTimeChange: PropTypes.func.isRequired,
  game: PropTypes.object,
  date: PropTypes.object,
  scale: PropTypes.string
};

TimeslotSelector.defaultProps = {
  scale: 'calendar'
};

export default TimeslotSelector;
